/*!
 *   Copyright 2022  SenX S.A.S.
 *
 *   Licensed under the Apache License, Version 2.0 (the "License");
 *   you may not use this file except in compliance with the License.
 *   You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 *   Unless required by applicable law or agreed to in writing, software
 *   distributed under the License is distributed on an "AS IS" BASIS,
 *   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *   See the License for the specific language governing permissions and
 *   limitations under the License.
 */

@import "../../scss/vars";

:host {
  width: 100%;
  height: 100%;

  & > div {
    display: flex;
    justify-content: start;
    align-items: center;
  }

  .discovery-back-drop {
    background-color: var(--warp-view-modal-backdrop-color, #00000066);
    padding: 20px;
    justify-content: center;
    --warp-view-font-color: #{$w10-white};
    --warp-view-spinner-size: 50px;
    font-weight: bold;
    height: calc(100% - 40px);
  }

  span.message {
    color: var(--warp-view-font-color, $w10-charcoal);
    padding-left: 10px;
  }

  .hidden {
    color: transparent;
    font-size: 0;
    height: 0;
    overflow: hidden;
  }

  .loader {
    width: var(--warp-view-spinner-size, 12px);
    height: var(--warp-view-spinner-size, 12px);
    border: calc(var(--warp-view-spinner-size, 12px) / 10) solid transparent;
    border-bottom-color: var(--warp-view-spinner-color, $w10-orange);
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
  }

  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
}
